import { Box, Divider, Typography, useTheme } from '@material-ui/core';
import { AppCheckbox } from 'components/atoms/StyledFormControls';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import _ from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  ITabContentProps,
  PropertyFilterType,
  YearBuiltOptions,
} from '../configuration';
import ProductFilterActions from '../store/actions';

const TabYearBuilt = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const dataValue =
    props.selections[PropertyFilterType.YearBuilt].data.year_built;
  const isChecked = (currentKey: string) => {
    var isChecked = false;
    for (let key of Object.keys(props.selections.YearBuilt.data))
      if (key !== currentKey)
        isChecked =
          isChecked || _.get(props.selections.YearBuilt.data, key, null);
    return isChecked;
  };
  const onValueChange = (key: string, value: string | number | null) => {
    if (value === 'null') value = null;
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.YearBuilt]: {
          ...props.selections[PropertyFilterType.YearBuilt],
          ...(isChecked(key) || value
            ? { isChecked: true }
            : { isChecked: false }),
          data: {
            ...props.selections[PropertyFilterType.YearBuilt].data,
            [key]: value,
          },
        },
      })
    );
  };
  return (
    <Box
      style={{
        position: 'relative',
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2
          translationKey={`year_built`}
          defaultText="Year built"
        />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Select one'} />
      </Typography>
      {YearBuiltOptions.map((option, index) => {
        return (
          <React.Fragment key={option.id}>
            <Box
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              style={{
                padding: '.25rem',
                paddingLeft: 0,
                cursor: 'pointer',
              }}
              onClick={() => onValueChange('year_built', option.id)}
            >
              <AppCheckbox size={'medium'} checked={dataValue === option.id} />
              <Typography style={{ marginLeft: '12px' }}>
                {`Up to ${option.label} years`}
              </Typography>
            </Box>
            {index + 1 < YearBuiltOptions.length ? <Divider /> : null}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default TabYearBuilt;
